import { http } from "@/http/axios.js";

/**
 * 大区分页
 * @param {{ page?: number, pageSize?: number }} params
 * @param {number} [params.page] - 页码
 * @param {number} [params.pageSize] - 每页条数
 * @returns {Promise<{
 *   page: number,
 *   pageSize: number,
 *   total: number,
 *   totalPage: number,
 *   list: Array<{
 *     id: number,
 *     areaName: string,
 *     subAreaList: Array<{
 *       id: number,
 *       areaName: string,
 *       followUserId: number | null,
 *       followUserName: string | null,
 *       sort: number | null,
 *       status: number | null,
 *       remark: string | null,
 *       cityCount: number | null
 *     }>
 *   }>
 * }>}
 */
/**
 * 新增大区
 * @param {{ areaName: string, followUserId: number }} data
 * @param {string} data.areaName - 大区名称
 * @param {number} data.followUserId - 区域跟进人id
 * @returns {Promise<{ id: number }>}
 */
export function addTopAreaAPI(data) {
  return http({
    url: "/admin/store/topArea/add",
    method: "post",
    data,
  });
}

/**
 * 编辑大区
 * @param {{ id: number, areaName: string, followUserId: number, followUserName: string }} data
 * @param {number} data.id - 大区id
 * @param {string} data.areaName - 区域名称
 * @param {number} data.followUserId - 大区跟进人id
 * @param {string} data.followUserName - 大区跟进人名称
 * @returns {Promise<boolean>}
 */
export function editTopAreaAPI(data) {
  return http({
    url: "/admin/store/topArea/edit",
    method: "post",
    data,
  });
}

/**
 * 大区详情
 * @param {number|string} id - 大区id
 * @returns {Promise<{
 *   id: number,
 *   areaName: string,
 *   followUserId: number,
 *   followUserName: string,
 *   sort: number,
 *   status: number,
 *   remark: string,
 *   subAreaList: Array<{
 *     id: number,
 *     areaName: string,
 *     followUserId: number,
 *     followUserName: string,
 *     sort: number,
 *     status: number,
 *     remark: string,
 *     cityCount: number
 *   }>,
 *   provinceCityStatList: Array<{
 *     provinceRegionId: number,
 *     provinceName: string,
 *     cityCount: number,
 *     cityNameList: string[]
 *   }>
 * }>}
 */
export function getTopAreaDetailAPI(id) {
  return http({
    url: "/admin/store/topArea/detail",
    method: "get",
    params: { id },
  });
}

/**
 * 删除大区
 * @param {number} id - 大区id
 * @returns {Promise<null>}
 */
export function deleteTopAreaAPI(id) {
  return http({
    url: "/admin/store/topArea/delete",
    method: "post",
    data: { id },
  });
}

export function getTopAreaPageAPI(params) {
  return http({
    url: "/admin/store/topArea/page",
    method: "get",
    params,
  });
}

// ==================== 分区 ====================

/**
 * 分区详情
 * @param {number|string} id - 分区id
 * @returns {Promise<{
 *   id: number,
 *   topAreaId: number,
 *   topAreaName: string,
 *   areaName: string,
 *   followUserId: number,
 *   followUserName: string,
 *   sort: number,
 *   status: number,
 *   remark: string,
 *   cityCount: number,
 *   provinceCityStatList: Array<{
 *     provinceRegionId: number,
 *     provinceName: string,
 *     cityCount: number,
 *     cityNameList: string[]
 *   }>
 * }>}
 */
/**
 * 新增分区
 * @param {{
 *   topAreaId: number,
 *   topAreaName: string,
 *   areaName: string,
 *   followUserId: number,
 *   followUserName: string,
 *   cityList: Array<{
 *     provinceRegionId: number,
 *     provinceName: string,
 *     cityRegionId: number,
 *     cityName: string
 *   }>
 * }} data
 * @returns {Promise<{ id: number }>}
 */
/**
 * 编辑分区
 * @param {{
 *   id: number,
 *   topAreaId: number,
 *   topAreaName: string,
 *   areaName: string,
 *   followUserId: number,
 *   followUserName: string,
 *   cityList: Array<{
 *     provinceRegionId: number,
 *     provinceName: string,
 *     cityRegionId: number,
 *     cityName: string
 *   }>
 * }} data
 * @returns {Promise<null>}
 */
/**
 * 删除分区
 * @param {number} id - 分区id
 * @returns {Promise<boolean>}
 */
export function deleteSubAreaAPI(id) {
  return http({
    url: "/admin/store/subArea/delete",
    method: "post",
    data: { id },
  });
}

export function editSubAreaAPI(data) {
  return http({
    url: "/admin/store/subArea/edit",
    method: "post",
    data,
  });
}

export function addSubAreaAPI(data) {
  return http({
    url: "/admin/store/subArea/add",
    method: "post",
    data,
  });
}

export function getSubAreaDetailAPI(id) {
  return http({
    url: "/admin/store/subArea/detail",
    method: "get",
    params: { id },
  });
}

/**
 * 获取已被其他分区占用的城市列表（用于新增/编辑时置灰）
 * @param {number} [excludeSubAreaId] - 编辑时传入，排除当前分区自身已占用的城市
 * @returns {Promise<Array<{
 *   provinceRegionId: number,
 *   provinceName: string,
 *   cityRegionId: number,
 *   cityName: string,
 *   topAreaId: number,
 *   topAreaName: string,
 *   subAreaId: number,
 *   subAreaName: string
 * }>>}
 */
export function getOccupiedCityListAPI(excludeSubAreaId) {
  return http({
    url: "/admin/store/subArea/occupiedCity/list",
    method: "get",
    params: excludeSubAreaId ? { excludeSubAreaId } : {},
  });
}
